import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../components/Landing/Footer";
import Header from "../components/Landing/Header";
import MobileQuickLinks from "../components/Landing/MobileQuickLinks";
import Tutorial, { TUTORIAL_FLAG } from "../components/Tutorial/Tutorial";
import { SigninModalProvider } from "../context/SigninModalContext";

const Layout = ({ children }) => {
  const location = useLocation();
  const path = location.pathname || "";

  // Set by the signin action when the account was just created. Read once on
  // mount, since signin lands here via a full page load.
  const [showTutorial, setShowTutorial] = useState(
    () => localStorage.getItem(TUTORIAL_FLAG) === "1"
  );
  // Marketing pages use a full-width shell so fixed #header-main stays
  // viewport-centered (not trapped in the 960px app column).
  const isLandingHome = path === "/" || path === "";
  const isMarketingPage =
    isLandingHome || path === "/about" || path.startsWith("/blog");

  useEffect(() => {
    if (path.indexOf("/share/together") === 0) {
      document.title = "My OllaCart";
    }
  }, [path]);

  // Flags pages rendered inside another site/app's frame (e.g. the iOS
  // app's webview) — that frame isn't sized to the screen, so CSS that
  // relies on position:fixed against the visible viewport (like the
  // mobile bottom nav bar in layout.scss) can't be used there; see the
  // is-embedded selectors in layout.scss.
  useEffect(() => {
    if (window.self !== window.top) {
      document.documentElement.classList.add("is-embedded");
    }
  }, []);

  const shellClass = isLandingHome
    ? ""
    : isMarketingPage
      ? "marketing-layout"
      : "main-content";

  const shell = (
    <>
      <Header />
      {/* App pages: content fills at least one screen (see --oc-main-min) so
          the footer stays below the fold on phones. */}
      {shellClass === "main-content" ? <div className="app-main">{children}</div> : children}
      {shellClass === "main-content" && <MobileQuickLinks />}
      <Footer />
      <Tutorial open={showTutorial} onClose={() => setShowTutorial(false)} />
    </>
  );

  return (
    <div className={shellClass}>
      {isMarketingPage ? (
        <SigninModalProvider>{shell}</SigninModalProvider>
      ) : (
        shell
      )}
    </div>
  );
};

export default Layout;
